{
  "upgrade_modal": {
    "title": "Upgrade your plan",
    "title_meeting_minutes": "You've run out of meeting minutes this month",
    "title_limit_reached": "You've reached your plan limit",
    "title_feature_locked": "Unlock more with a higher plan",
    "limit_reason": "You've reached the limit of your current plan ({plan}).",
    "feature_reason": "This feature is available on a higher plan.",
    "limit_detail": {
      "members": "You're at the {limit}-member cap.",
      "active_tasks": "You're at the {limit}-task cap.",
      "storage_bytes": "You've hit your storage cap.",
      "meeting_minutes_monthly": "You've used all your AI meeting minutes this month."
    },
    "current_plan_label": "Current plan",
    "trial_label": "trial",
    "meeting_options_intro": "You have two options:",
    "meeting_option_pack": "Buy a pack",
    "meeting_option_pack_detail": "of extra minutes from $1 — they don't expire.",
    "meeting_option_business": "Upgrade to Business",
    "meeting_option_business_detail": "to get 50h/month included.",
    "pro_pitch_lead": "With",
    "pro_pitch_body": "you get unlimited members, tasks, and storage, plus timeline, custom fields, templates, and more.",
    "cta_view_plans": "View plans",
    "cta_close": "Close",
    "cta_later": "Later",
    "cta_buy_pack": "Buy pack",
    "generic_message": "Your current plan doesn't allow this action."
  },
  "page": {
    "title": "Plans & billing",
    "subtitle": "Pick the plan that fits your team. Change it whenever you want.",
    "on_trial": "You're on Pro trial — {n} days remaining",
    "cycle_monthly": "Monthly",
    "cycle_yearly": "Yearly",
    "yearly_discount": "−16%",
    "loading_plans": "Loading plans…",
    "subscription_trialing": "Subscription on trial",
    "subscription_active": "Active subscription",
    "ends_on": "Ends on {date}",
    "manage_subtitle": "Manage payment method, invoices, and cancellation from the Stripe portal",
    "opening": "Opening…",
    "manage": "Manage",
    "most_popular": "Most popular",
    "current_label": "Current",
    "per_workspace_month": "/ workspace / month",
    "per_workspace_year": "/ workspace / month, billed yearly",
    "seats_included": "Includes {n} seats · ${price} per extra seat / {cycle}",
    "team_estimate": "Your team ({members} members, {extra} extra): ${total} / {cycle}",
    "cycle_unit_month": "month",
    "cycle_unit_year": "year",
    "billed_yearly": "billed ${price}/year",
    "forever": "Forever",
    "owner_only_upgrade": "Only the team owner can upgrade",
    "cta_current_plan": "Your current plan",
    "cta_start_free": "Start for free",
    "cta_redirecting": "Redirecting…",
    "cta_upgrade": "Upgrade",
    "cta_switch": "Switch to this plan",
    "cta_switching": "Switching…",
    "switch_confirm_title": "Switch to {plan}?",
    "switch_confirm_message": "The change applies right away. We charge or credit the difference for the rest of the current period on your card on file.",
    "switch_confirm_cta": "Switch plan",
    "msg_plan_switched": "Plan updated! Your new features are available now.",
    "members_unit": "members",
    "members_unlimited": "Unlimited members",
    "active_tasks_unit": "active tasks",
    "active_tasks_unlimited": "Unlimited active tasks",
    "storage_suffix": "of storage",
    "storage_unlimited": "Unlimited storage",
    "meeting_duration_cap": "up to {n} min per meeting",
    "minutes_unlimited": "Unlimited AI minutes",
    "minutes_with_hours": "{value} min ({hrs}h) AI transcription/month",
    "minutes_only": "{value} min AI transcription/month",
    "unlimited": "Unlimited",
    "unlimited_lower": "unlimited",
    "free": "Free",
    "packs": {
      "label": "Extra minutes",
      "title": "Running short this month?",
      "subtitle": "Buy extra AI meeting minutes. They don't expire and stack on top of your monthly quota.",
      "bonus_available": "You have {minutes} extra available",
      "most_popular": "Most popular",
      "minutes_hours": "{minutes} min ({hours} hours)",
      "never_expire": "Never expire",
      "per_hour": "{price}/hour",
      "buy": "Buy",
      "owner_only_buy": "Only the team owner can buy extra minutes."
    },
    "footer": "Payments processed securely by Stripe. Cancel whenever you want.",
    "msg_subscription_activated": "Subscription activated! It can take a few seconds to sync.",
    "msg_canceled": "Process canceled. You can try again whenever you want.",
    "msg_pack_purchased": "Minute pack purchased! It will be credited in seconds.",
    "msg_pack_canceled": "Pack purchase canceled.",
    "error_owner_only_pack": "Only the team owner can buy minutes.",
    "error_pack_purchase": "Couldn't start the pack purchase.",
    "error_owner_only_billing": "Only the team owner can manage billing.",
    "error_checkout": "Couldn't start checkout. Make sure Stripe is configured on the server.",
    "error_portal": "Couldn't open the billing portal.",
    "cta_downgrade_free": "Downgrade to Free",
    "usage": {
      "title": "Your current usage",
      "subtitle": "{plan} plan",
      "members": "Members",
      "active_tasks": "Active tasks",
      "storage": "Storage",
      "minutes": "AI minutes this month",
      "no_limit": "{used} · no limit"
    }
  },
  "features": {
    "ai_meetings": "🎙️ AI meetings — transcription + auto tasks",
    "ai_summary": "✨ Executive summaries with AI",
    "ai_triage": "✨ AI triage (text → structured task)",
    "time_tracking": "Time tracking",
    "kanban": "Kanban view",
    "list_view": "List view",
    "my_tasks": "My tasks view",
    "timeline": "Timeline / Gantt",
    "calendar": "Calendar",
    "subtasks": "Subtasks",
    "comments": "Comments",
    "realtime_chat": "Real-time chat",
    "attachments": "Attachments",
    "tags": "Tags",
    "in_app_notifications": "In-app notifications",
    "email_notifications": "Email notifications",
    "custom_fields": "Custom fields",
    "templates": "Project templates",
    "automation_rules": "Automation rules",
    "forms": "Public forms",
    "dashboards": "Dashboards",
    "export_csv": "Export to CSV",
    "activity_log_full": "Full activity log",
    "portfolios": "Portfolios",
    "goals": "Goals / OKRs",
    "workload": "Team workload",
    "approvals": "Approvals",
    "external_guests": "External guests",
    "sso": "SSO (SAML)",
    "api_public": "Public API",
    "webhooks": "Webhooks",
    "priority_support": "Priority support"
  }
}
